export default __webpack_public_path__ + "static/media/logo.057e58bf.png";